module.exports = __webpack_public_path__ + "static/media/arrowBottomIcon.1743437c.svg";